<div class="p-3">
  <page-heading
    [title]="'integrations.webhookRequestsView.title' | translate"
    [description]="'integrations.webhookRequestsView.description' | translate"
  />

  <div class="d-flex justify-end gap-2 mb-2">
    <button
      (click)="showPayload()"
      class="btn btn-outline-i"
      [ngClass]="{ active: viewMode === 'payload' }"
    >
      {{ 'integrations.webhookRequestsView.viewPayload' | translate }}
    </button>
    <button
      (click)="showCurl()"
      class="btn btn-outline-i"
      [ngClass]="{ active: viewMode === 'curl' }"
    >
      {{ 'integrations.webhookRequestsView.viewCurl' | translate }}
    </button>
  </div>

  <hr class="my-2" />
  <div class="row">
    <div class="col-12 position-relative">
      @if(viewMode === 'curl') {
      <div
        class="position-absolute d-flex align-items-center border px-2 py-1 gap-1 rounded bg-white"
        style="top: 10px; right: 28px; cursor: pointer"
        (click)="copyContent()"
      >
        {{ copied ? ('integrations.webhookRequestsView.copied' | translate) : ('integrations.webhookRequestsView.copy' | translate) }}
        <i class="bi bi-clipboard text-gray-500"></i>
      </div>
      }
      <div
        class="row overflow-auto border rounded p-3 bg-light"
        style="max-height: 500px"
      >
        @if(viewMode === 'payload'){
        <pre><code>{{ webhook | json }}</code></pre>
        } @else {
        <pre><code>{{ curlContent }}</code></pre>
        }
      </div>
    </div>
  </div>
</div>
